module.exports = __webpack_public_path__ + "static/img/组 1.82f2b2a1.png";